import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getPColorAll = (_params, onSuccess, onError) => {
    _params.filterAndNegative = 'language_code:en';
    _params.orders= 'name';
    const response = axios.get('v1/admin/product-color', { params: _params });
    return handleResponse(response, onSuccess, onError);
};


export const getLanguages = (_params, onSuccess, onError) => {
    _params.filterAndNegative = 'language_code:en';
    _params.orders= 'language_name:asc';
    const response = axios.get(`v1/admin/language`, { params: _params });
    return handleResponse(response, onSuccess, onError);
}

export const getPColorById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/product-color/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createPColor = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/product-color`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updatePColor = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/product-color/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeletePColor = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/product-color/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deletePColor = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/product-color/${id}`);
    return handleResponse(response, onSuccess, onError);
};